<template>
  <div>
      <!-- page wrapper start -->
    <div class="pg-wrapper edit-account">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <button @click="goBack()" class="button is-flex nav-back">
            <img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back">
          </button>
            <h1 class="title has-text-black">Membership</h1>
        </div>
      </app-header>
      <main class="content-wrapper">
        <section class="section pt0">
          <div class="container">
            <div class="columns justify-content-center">
              <div class="column is-12-tablet is-9-desktop">
                <user-menu/>
                <!-- loyality card -->
                <div class="loyalty-business-record-wrap" v-if="vg_businessLoyality.id && vg_businessLoyality.is_active">
                  <div class="loyalty-business-card-wrap">
                    <div class="loyalty-card-wrap is-full-mobile">
                      <div class="loyalty-card relative" :style="cardStyle">
                        <p class="loyalty-business-detail">
                          <span class="has-text-weight-semibold is-size-18">{{ vg_businessLoyality.name }}</span><br/>
                          <span class="is-size-14 has-text-weight-semibold">You have {{ vg_userLoyalitySubscriptionObj.points ?  new Intl.NumberFormat().format(vg_userLoyalitySubscriptionObj.points) : '0' }} points</span><br/>
                          <span class="is-size-14 has-text-weight-light" v-if="vg_businessLoyality.settings && vg_businessLoyality.settings.points_for_dollar">{{ vg_businessLoyality.settings.points_for_dollar }} points = $1</span>
                        </p>
                        <!-- <span class="enthusiast-tag" :style="`background:${vg_businessLoyality.branding ? vg_businessLoyality.branding.accent_color : ''}`">Enthusiast</span> -->
                        <figure class="loyalty-card-logo" v-if="vg_businessLoyality.branding  && vg_businessLoyality.branding.logo_url">
                          <img :src="vg_businessLoyality.branding.logo_url" alt=""/>
                        </figure>
                        <div class="membership-card-badge-details text-center" v-if="vg_userLoyalityBagdes && vg_userLoyalityBagdes.length > 0">
                          <p class="is-size-14">Badges Earned</p>
                          <p><span class="is-size-48px">{{ vg_userLoyalityEarnedBagdes.length }}</span><span class="opacity-03">/{{ vg_userLoyalityBagdes.length }}</span></p>
                        </div>
                      </div>
                    </div>
                    <div class="redeem-points-info is-full-mobile">
                      <div class="loyalty-referral-main">
                        <div class="loyalty-referral-wrap" v-if="shareableReferralUrl">
                          <p class="is-size-14 has-text-weight-semibold" v-if="vg_businessLoyality.referral_action">Refer a friend, after their first order, you’ll both get {{ vg_businessLoyality.referral_action.earn_value ? vg_businessLoyality.referral_action.earn_value : '0' }} points!</p>
                          <div class="loyalty-referlink-wrap has-secondary-border" ref="cloneParent">
                            <span  ref="cloneMain" v-html="shareableReferralUrl"></span>
                            <a href="#" @click.prevent="copyToClipboard()" class="copy has-inner-svg-secondary hover-opacity-7">
                              <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 0H2.5C1.4 0 0.5 0.9 0.5 2V16H2.5V2H14.5V0ZM17.5 4H6.5C5.4 4 4.5 4.9 4.5 6V20C4.5 21.1 5.4 22 6.5 22H17.5C18.6 22 19.5 21.1 19.5 20V6C19.5 4.9 18.6 4 17.5 4ZM17.5 20H6.5V6H17.5V20Z" fill="#FFFFFF"/>
                              </svg>
                            </a>
                            <a href="#" @click.prevent="nativeShare()" class="share has-inner-svg-secondary hover-opacity-7">
                              <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 14.08C14.74 14.08 14.06 14.38 13.54 14.85L6.41 10.7C6.46 10.47 6.5 10.24 6.5 10C6.5 9.76 6.46 9.53 6.41 9.3L13.46 5.19C14 5.69 14.71 6 15.5 6C17.16 6 18.5 4.66 18.5 3C18.5 1.34 17.16 0 15.5 0C13.84 0 12.5 1.34 12.5 3C12.5 3.24 12.54 3.47 12.59 3.7L5.54 7.81C5 7.31 4.29 7 3.5 7C1.84 7 0.5 8.34 0.5 10C0.5 11.66 1.84 13 3.5 13C4.29 13 5 12.69 5.54 12.19L12.66 16.35C12.61 16.56 12.58 16.78 12.58 17C12.58 18.61 13.89 19.92 15.5 19.92C17.11 19.92 18.42 18.61 18.42 17C18.42 15.39 17.11 14.08 15.5 14.08Z" fill="#FFFFFF"/>
                              </svg>
                            </a>
                          </div>
                          <div class="desktop-social-share" ref="desktop_social_share">
                            <ul>
                              <li><a :href="facebookShare" onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;" class="bg-secondary text-white hover-opacity-7" target="_blank"><i class="fab fa-facebook-square"></i> Share</a></li>
                              <li><a :href="twitterShare" onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;" class="bg-secondary text-white hover-opacity-7" target="_blank"><i class="fab fa-twitter-square"></i> Share</a></li>
                              <li><a :href="emailShare" class="bg-secondary text-white hover-opacity-7" target="_blank"><i class="fas fa-envelope"></i> Email</a></li>
                            </ul>
                          </div>
                        </div>
                        <p class="mt10"><a href="#" @click.prevent="openQuestionModal()" class="is-size-14 text-secondary hover-text-secondary hover-opacity-8 has-text-weight-semibold">HOW TO EARN AND REDEEM POINTS</a></p>
                      </div>
                    </div>
                  </div>

                  <div class="membership-sub-pages-nav">
                    <ul>
                      <li :class="(subpage.active ? 'active': '') + ' has-text-weight-semibold'" v-for="(subpage, index) in membershipSubPages" v-bind:key="'membershub'+ subpage.name">
                        <template v-if="subpage.template == 'Badges'">
                          <a v-if="vg_userLoyalityBagdes && vg_userLoyalityBagdes.length > 0" @click.prevent="switchPage(subpage, index)" class="text-secondary" href="#">{{ subpage.name  }}</a>
                        </template>
                        <a v-else @click.prevent="switchPage(subpage, index)" class="text-secondary" href="#">{{ subpage.name  }}</a>
                      </li>
                    </ul>
                  </div>
                  <component :is="activeSubPage.template" v-if="vg_userId && vg_businessLoyality.id && vg_businessLoyality.is_active" ></component>
                </div>
                <div v-else class="">
                  <p class="mt20">Membership is not available or inactive.</p>
                </div>

              </div>
            </div>
          </div>
        </section>
      </main>
      <order-receipt></order-receipt>
      <question-modal/>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import Env from '@/env';
import Helpers from '@/Components/Helpers/Helpers';
import { mapGetters, mapActions } from "vuex";
import { format } from "date-fns";
import UserMenu from '@/Components/Pages/User/Inc/UserNavMenu';
import TransactionHistory from '@/Components/Pages/User/Membership/TransactionHistory';
import Badges from '@/Components/Pages/User/Membership/Badges';
import QuestionModal from '@/Components/Pages/User/Membership/QuestionModal';
import OrderReceipt from "@/Components/Pages/User/Order/OrderReceipt";

export default {
  components: {
    UserMenu,
    TransactionHistory,
    OrderReceipt,
    QuestionModal,
    Badges,
  },
  data() {
    return {
      hasUserLoyalty: false,
      membershipSubPages: [
        {
          name: 'HISTORY',
          active: true,
          template: 'TransactionHistory',
        },
        {
          name: 'BADGES IN-PROGRESS',
          active: false,
          template: 'Badges',
        }
      ],
    }
  },
  
  computed: {
    // membershipSubPages() {
    //   let pages = [
    //     {
    //       name: 'HISTORY',
    //       active: true,
    //       template: 'TransactionHistory',
    //     },
    //   ];
    //   if(this.vg_userLoyalityEarnedBagdes && this.vg_userLoyalityEarnedBagdes.length > 0) {
    //     pages.push({
    //       name: 'BADGES IN-PROGRESS',
    //       active: false,
    //       template: 'Badges',
    //     })
    //   }
    //   return pages;
    // },

    activeSubPage() {
      return _.find (this.membershipSubPages, ['active', true]);
    },
    facebookShare() {
      // &t=${this.shareContent}
      return this.shareableReferralUrl ? 
        `https://www.facebook.com/sharer/sharer.php?u=${this.shareableReferralUrl}` :
        '';
    },
    twitterShare() {
      return this.shareableReferralUrl ? 
      `https://twitter.com/intent/tweet?text=${this.shareContent + ' ' + this.shareableReferralUrl}` :
      '';
    },
    emailShare() {
      return this.shareableReferralUrl ? 
      `mailto:?subject=Share and Earn&body=${this.shareContent + ' ' + this.shareableReferralUrl}` :
      '';
    },
    shareableReferralUrl() {
      if( !this.vg_userLoyalitySubscriptionObj.referral_key ){
        return '';
      }
      let url = window.location.protocol + '//' + 
                window.location.host +  '/' + 
                this.$route.params.business_slug + '/' + 
                this.vg_selectedStore.slug + '/shop?referral_key=' +
                this.vg_userLoyalitySubscriptionObj.referral_key;
      return url; 
    },
    /**
     * Generate content to share
     */
    shareContent() {
      if(this.vg_businessLoyality.name && this.vg_loggedInUser.id ) {
        return `${ this.vg_loggedInUser.first_name + ' ' +  this.vg_loggedInUser.last_name } has invited you to join ${ this.vg_businessLoyality.name }. Please follow the link`
      } else {
        return '';
      }
    },

    cardStyle() {
      if(this.vg_businessLoyality){
        let cardBgColor =   this.vg_businessLoyality.branding && this.vg_businessLoyality.branding.primary_color ? this.vg_businessLoyality.branding.primary_color : '';
        let cardBg =   this.vg_businessLoyality.branding && this.vg_businessLoyality.branding.card_background_image ? this.vg_businessLoyality.branding.card_background_image : '';
        return `background: ${cardBgColor} url(${cardBg}) center center / cover no-repeat`;
      }
      return '';
    },

  
    ...mapGetters({
      vg_userId: "getLoggedInUserId",
      vg_loggedInUser: "getLoggedInUser",
      vg_selectedStore: "location/selected", 
      vg_businessProfile: "businessprofile/detail",
      vg_businessLoyality: "businessprofile/businessLoyality",
      vg_userLoyalitySubscriptionObj: "userloyalitysubscription/obj",
      vg_userLoyalityEarnedBagdes: "userloyalitysubscription/earnedBadges",
      vg_userLoyalityBagdes: "userloyalitysubscription/badges",
    })
  },
  
  async mounted() {
    // Fetch and Set
    if(this.vg_userId && this.vg_businessLoyality.id && this.vg_businessLoyality.is_active){
      this.va_setUserLoyalityObj({
        user_id: this.vg_userId, 
        business_id: this.vg_businessProfile.id,
      }); 
    }
  },

  methods: {
   
    goBack() {
      this.$router.go(-1);
    },

    switchPage(obj , index) {
      this.membershipSubPages.map( (item, itemIndex) => {
        if(itemIndex == index) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
    },

    openQuestionModal() {
      bus.$emit('show-modal-loyalty-questions', true)
    },

    // Copy text
    copyToClipboard() {
      this.$refs.cloneParent.classList.add('copied');
      navigator.clipboard.writeText(this.shareableReferralUrl);
      setTimeout(() => {
          this.$refs.cloneParent.classList.remove('copied');
      }, 1000)
    },

   // Share
    nativeShare() {
      if(this.detectDevice() == 'desktop') {
        // make toggel
        let classes = Array.from(this.$refs.desktop_social_share.classList);
        if(classes.indexOf('active') < 0 ){
          this.$refs.desktop_social_share.classList.add('active');
        } else {
          this.$refs.desktop_social_share.classList.remove('active');
        }
      } else {
        if (navigator.share) {
          navigator.share({
            title: this.vg_businessLoyality.name,
            text: this.shareContent,
            url: this.shareableReferralUrl,
          })
          .then((success) => console.log(success))
          .catch((error) => console.log(error));
        }
      }
    },
    /**
     * Detect device
     */
     detectDevice() {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
          return "tablet";
        }
        else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
          return "mobile";
        }
        return "desktop";
     },

    ...mapActions({
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })
  },
};
</script>
